/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    FormatMetadata,
    FormatMetadataFromJSON,
    FormatMetadataFromJSONTyped,
    FormatMetadataToJSON,
    Proxy,
    ProxyFromJSON,
    ProxyFromJSONTyped,
    ProxyToJSON,
} from './';

/**
 * 
 * @export
 * @interface AssetMiniReference
 */
export interface AssetMiniReference {
    /**
     * 
     * @type {number}
     * @memberof AssetMiniReference
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof AssetMiniReference
     */
    readonly syncId?: string;
    /**
     * 
     * @type {Proxy}
     * @memberof AssetMiniReference
     */
    defaultProxy?: Proxy;
    /**
     * 
     * @type {string}
     * @memberof AssetMiniReference
     */
    readonly type?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetMiniReference
     */
    readonly displayName?: string;
    /**
     * 
     * @type {FormatMetadata}
     * @memberof AssetMiniReference
     */
    format?: FormatMetadata;
    /**
     * 
     * @type {{ [key: string]: string | undefined; }}
     * @memberof AssetMiniReference
     */
    readonly info?: { [key: string]: string | undefined; };
    /**
     * 
     * @type {boolean}
     * @memberof AssetMiniReference
     */
    readonly thumbnailGenerated?: boolean;
    /**
     * 
     * @type {Array<Proxy>}
     * @memberof AssetMiniReference
     */
    readonly proxies?: Array<Proxy>;
}

export function AssetMiniReferenceFromJSON(json: any): AssetMiniReference {
    return AssetMiniReferenceFromJSONTyped(json, false);
}

export function AssetMiniReferenceFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetMiniReference {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'syncId': !exists(json, 'sync_id') ? undefined : json['sync_id'],
        'defaultProxy': !exists(json, 'default_proxy') ? undefined : ProxyFromJSON(json['default_proxy']),
        'type': !exists(json, 'type') ? undefined : json['type'],
        'displayName': !exists(json, 'display_name') ? undefined : json['display_name'],
        'format': !exists(json, 'format') ? undefined : FormatMetadataFromJSON(json['format']),
        'info': !exists(json, 'info') ? undefined : json['info'],
        'thumbnailGenerated': !exists(json, 'thumbnail_generated') ? undefined : json['thumbnail_generated'],
        'proxies': !exists(json, 'proxies') ? undefined : ((json['proxies'] as Array<any>).map(ProxyFromJSON)),
    };
}

export function AssetMiniReferenceToJSON(value?: AssetMiniReference | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'default_proxy': ProxyToJSON(value.defaultProxy),
        'format': FormatMetadataToJSON(value.format),
    };
}


